module.exports = __webpack_public_path__ + "img/Member icon-06.693412e3.png";